// extracted by mini-css-extract-plugin
export default {"TableRow":"CodPagamento_TableRow__nQRP1"};